import React from 'react';
import { FaStar, FaMapMarkerAlt, FaTruck, FaShieldAlt } from 'react-icons/fa';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function SellerBlock({ seller, eta, warrantyMonths, embedded = false }) {
  const { isDark } = useThemeClasses();

  if (!seller) return null;

  return (
    <div
      className={
        embedded
          ? ''
          : isDark
            ? 'rounded-sm border border-slate-700/60 bg-slate-800/50 p-5 sm:p-6'
            : 'rounded-sm border border-slate-200 bg-white p-5 sm:p-6 shadow-sm'
      }
    >
      {!embedded && (
        <p className={`text-xs font-semibold uppercase tracking-wide ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
          Seller &amp; delivery
        </p>
      )}

      <div
        className={`flex flex-wrap items-center gap-x-4 gap-y-2 text-sm ${
          embedded ? '' : 'mt-3'
        } ${isDark ? 'text-slate-200' : 'text-slate-700'}`}
      >
        <span className="inline-flex items-center gap-1.5 font-medium">
          <FaMapMarkerAlt className={isDark ? 'text-slate-400' : 'text-slate-500'} />
          {seller.city || '—'}
        </span>
        <span className="inline-flex items-center gap-1">
          <FaStar className="text-amber-400" />
          <span className={`font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>
            {seller.ratingLabel === 'New seller' || seller.rating == null
              ? 'New seller'
              : Number(seller.rating || 0).toFixed(1)}
          </span>
          {seller.rating != null && seller.ratingLabel !== 'New seller' && (
            <span className={isDark ? 'text-slate-500' : 'text-slate-500'}>Rating</span>
          )}
        </span>
        {eta && (
          <span className={`inline-flex items-center gap-1.5 ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
            <FaTruck className={isDark ? 'text-slate-400' : 'text-slate-500'} />
            {eta}
          </span>
        )}
        {warrantyMonths != null && (
          <span className={`inline-flex items-center gap-1.5 ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
            <FaShieldAlt className={isDark ? 'text-slate-400' : 'text-slate-500'} />
            {warrantyMonths} mo warranty
          </span>
        )}
      </div>

      {seller.badges?.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {seller.badges.map((badge) => (
            <span
              key={badge}
              className={`rounded-md px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
                isDark
                  ? 'bg-slate-700/80 text-slate-300'
                  : 'bg-slate-100 text-slate-700 border border-slate-200'
              }`}
            >
              {badge}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
